import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  firstDate: { year: number; month: number } | null = null;
  lastDate: { year: number; month: number } | null = null;
  static readonly monthLabels: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  getFormattedMonthYear(date: Date): string {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${year}-${month < 10 ? '0' + month : month}`;
  }

  /*
   * Returns date in format MMMM YYYY, if first is true returns first date, otherwise returns last date.
   */
  getFormatedDateLimit(first = false): string {
    const date = first ? this.firstDate : this.lastDate;
    if (!date) {
      return '';
    }
    const month = CalendarService.monthLabels[date.month - 1];
    return `${month} ${date.year}`;
  }
}
